import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import NoItemResult from '../../../../components/results/NoItemResult';

const InsuranceModuleEmptyList = () => {
    const { t } = useTranslation(['insuranceModuleDetails']);
    const navigate = useNavigate();

    return (
        <NoItemResult
            extra={
                <Button onClick={() => navigate('/admin/insurers/add')} type="primary">
                    {t('insuranceModuleDetails:emptyList.noData.action')}
                </Button>
            }
            subTitle={t('insuranceModuleDetails:emptyList.noData.message')}
        />
    );
};

export default InsuranceModuleEmptyList;
